"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressLookupWidget = void 0;
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var rxjs_1 = require("rxjs");
var journey_services_1 = require("@athena-portal/journey-services");
var react_router_dom_1 = require("react-router-dom");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var commonFunctions_1 = require("../commonFunctions");
var React = require("react");
var components_1 = require("@athena-portal/components");
var AddressLookupWidget = exports.AddressLookupWidget = /** @class */ (function (_super) {
    __extends(AddressLookupWidget, _super);
    function AddressLookupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setAddressChangeReferer = function () {
            window.sessionStorage.setItem(services_1.SessionStorageItemEnum.ADDRESS_CHANGE_REFERER, window.location.href);
        };
        _this.onSelectAddress = _this.onSelectAddress.bind(_this);
        _this.processAddressResponse = _this.processAddressResponse.bind(_this);
        _this.toggleShowAddress = _this.toggleShowAddress.bind(_this);
        _this.handleBuildingChange = _this.handleBuildingChange.bind(_this);
        _this.handlePostcodeChange = _this.handlePostcodeChange.bind(_this);
        _this.findAddress = _this.findAddress.bind(_this);
        _this.renderFoundAddresses = _this.renderFoundAddresses.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        var address;
        _this.interactionAddress = _this.getSetting("interactionAddress");
        if (_this.interactionAddress) {
            address = journey_services_1.ObjectManipulator.fetchFieldValue(_this.interactionAddress, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionAddress' setting"));
        }
        var fullAddress = address ? address.fullAddress : "";
        var showAddress = !!fullAddress;
        _this.disablePostcodeSelection = _this.getSetting("disablePostcodeSelection", false);
        _this.disabledPostcodeSetting = _this.getSetting("disabledPostcode");
        _this.hideQuestionsOnChange = _this.getSetting("hideQuestionsOnChange", false);
        var disabledPostcodeValue = "";
        if (_this.disabledPostcodeSetting) {
            disabledPostcodeValue = journey_services_1.ObjectManipulator.fetchFieldValue(_this.disabledPostcodeSetting, _this.props.interaction);
        }
        _this.state = {
            postcode: _this.disablePostcodeSelection ? disabledPostcodeValue : "",
            building: "",
            fullAddress: fullAddress,
            addressList: [],
            typingTimeout: 0,
            subscription: rxjs_1.Subscription.EMPTY,
            address: address,
            serviceError: false,
            showAddress: showAddress,
            showAddressList: false,
            noAddressFound: false,
            postcodeValidated: true,
            postcodeErrorMessage: "",
            isMobileScreenSize: window.innerWidth < 768,
            isLoading: false,
        };
        return _this;
    }
    AddressLookupWidget.prototype.componentDidUpdate = function () {
        var addressFromInteraction = journey_services_1.ObjectManipulator.fetchFieldValue(this.interactionAddress, this.props.interaction);
        if (addressFromInteraction && this.state.fullAddress !== addressFromInteraction.fullAddress) {
            this.setState({
                fullAddress: addressFromInteraction.fullAddress,
                address: addressFromInteraction,
                showAddress: !!addressFromInteraction.fullAddress
            });
            this.props.onStateChange(this.props.question.interactionField, addressFromInteraction);
        }
        window.addEventListener("resize", this.resize.bind(this));
    };
    AddressLookupWidget.prototype.render = function () {
        var _a;
        var htmlLabel = this.getSetting("htmlLabel");
        var statedLabel = (this.state.showAddress ? "Property address" : "What’s the property address?");
        var label = (_a = this.props.question.label) !== null && _a !== void 0 ? _a : statedLabel;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "address-lookup form-group ".concat(this.getSetting("cssClass", "")) },
                React.createElement("label", { htmlFor: this.props.question.name },
                    htmlLabel ? this.renderHtml(htmlLabel) : label,
                    this.isMandatory() &&
                        (this.props.journey && process.env.REACT_APP_MANDATORY_QUESTION_SUFFIX ? process.env.REACT_APP_MANDATORY_QUESTION_SUFFIX : " *")),
                React.createElement("div", { className: "input-group", role: this.getSetting("role", ""), "aria-label": this.getSetting("ariaLabel", "") }, this.renderInputField()),
                _super.prototype.renderValidationResult.call(this),
                this.getSetting("validFeedback") && this.isValid() && React.createElement("div", { className: "valid-feedback d-block" }, this.getSetting("validFeedback"))),
            React.createElement(components_1.Overlay, { show: this.state.isLoading })));
    };
    AddressLookupWidget.prototype.renderDisplayAddress = function () {
        var capitalize = function (txt) {
            return txt != null ?
                txt.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); }).join(' ') : "";
        };
        var addressLine1 = "";
        var addressLine2 = "";
        var addressLine3 = "";
        var addressLine4 = "";
        if (this.state.address) {
            addressLine1 = (capitalize(this.state.address.organisationName) + " " + capitalize(this.state.address.subBuildingName) + " " + capitalize(this.state.address.buildingName)).trim();
            addressLine2 = ((this.state.address.buildingNumber ? this.state.address.buildingNumber + " " : "")
                + capitalize(this.state.address.dependentThoroughfareName ? this.state.address.dependentThoroughfareName + " " : "")
                + capitalize(this.state.address.dependentThoroughfareDescriptor ? this.state.address.dependentThoroughfareDescriptor + " " : "")
                + capitalize(this.state.address.thoroughfareName) + " "
                + capitalize(this.state.address.thoroughfareDescriptor) + ", ").trim();
            addressLine3 = (capitalize(this.state.address.doubleDependentLocality ? this.state.address.doubleDependentLocality + ", " : "")
                + capitalize(this.state.address.dependentLocality ? this.state.address.dependentLocality + ", " : "")
                + capitalize(this.state.address.postTown)).trim();
            addressLine4 = (this.state.address.outwardPostcode + " " + this.state.address.inwardPostcode).trim();
        }
        return (React.createElement("div", { className: "address-display", id: "address-display" },
            addressLine1 && React.createElement("div", { id: "address-line-1" }, addressLine1),
            addressLine2 && React.createElement("div", { id: "address-line-2" }, addressLine2),
            addressLine3 && React.createElement("div", { id: "address-line-3" }, addressLine3),
            addressLine4 && React.createElement("div", { id: "address-line-4" }, addressLine4),
            this.renderAddressChangeOption()));
    };
    AddressLookupWidget.prototype.renderAddressChangeOption = function () {
        var _this = this;
        if (this.props.interaction.subscriptionInfo && this.props.interaction.subscriptionInfo.hasActivePolicies) {
            return (React.createElement("div", { id: "address-change-warning", className: "d-flex align-items-start bg-white-blue rounded p-3 mt-3" },
                React.createElement("img", { className: "d-block mr-3 mt-1", src: "/img/Flow-attention.svg", alt: "warning" }),
                React.createElement("div", null,
                    "Changes in your address might affect your subscription price. You can",
                    " ",
                    React.createElement(react_router_dom_1.Link, { id: "edit-your-address-link", to: "/dashboard", className: "text-decoration-underline cursor-pointer text-blue-1", onClick: this.setAddressChangeReferer },
                        React.createElement("b", null, "edit your address")),
                    " ",
                    "in your account space")));
        }
        else if (this.isReadOnly()) {
            return (React.createElement(React.Fragment, null));
        }
        else {
            return (React.createElement("button", { className: "btn btn-text btn-panel-edit", onClick: function () { return _this.toggleShowAddress(false); } }, "Change address"));
        }
    };
    AddressLookupWidget.prototype.renderAddressInput = function () {
        var whiteBackground = this.getSetting("whiteBackground");
        var invalidInput = !this.state.postcodeValidated || (this.state.noAddressFound && this.state.postcodeValidated);
        var removePostcodeMargins = this.hideQuestionsOnChange && !this.state.showAddressList;
        var inputClass = "";
        if (invalidInput) {
            inputClass = " is-invalid";
        }
        else if (this.state.showAddressList) {
            inputClass = " is-valid";
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "".concat(whiteBackground ? "" : "background-color-grey", " inner-content negative-margin py-2 mb-4") },
                React.createElement("div", { className: "form-group address" },
                    React.createElement("p", { className: "font-weight-semi-bold" },
                        "House number or name ",
                        React.createElement("span", { className: "font-weight-normal-custom" }, "(optional)")),
                    React.createElement("input", { type: "text", className: "form-control".concat(this.state.building.length > 0 ? " is-valid" : ""), id: "addressLookupWidget-".concat(this.props.question.name, "-building"), value: this.state.building, onChange: this.handleBuildingChange })),
                React.createElement("div", { className: "".concat(whiteBackground ? 'row' : '') },
                    React.createElement("div", { className: "form-group postcode col ".concat(this.state.isMobileScreenSize ? "address-postcode-mobile " : " ", " ").concat(removePostcodeMargins ? "mb-0 pb-0" : "") },
                        React.createElement("p", { className: "font-weight-semi-bold text-nowrap" },
                            "Postcode ",
                            React.createElement("span", { className: "font-weight-normal-custom" }, "(UK only)")),
                        React.createElement("input", { type: "text", className: "form-control".concat(inputClass), id: "addressLookupWidget-".concat(this.props.question.name, "-postcode"), value: this.state.postcode, onChange: this.handlePostcodeChange, disabled: this.disablePostcodeSelection })),
                    whiteBackground && React.createElement("div", { className: this.state.isMobileScreenSize ? "col mt-1 div-find-address-postcode" : "col-2 mt-1 div-find-address-postcode" },
                        React.createElement("button", { className: 'btn btn-primary btn-next-arrow-separate btn-find-address', id: 'find-address', onClick: this.handleSubmit }, "Find address"))),
                !this.state.postcodeValidated && (React.createElement("div", { className: "invalid-feedback d-block" }, this.state.postcodeErrorMessage)),
                this.state.noAddressFound && this.state.postcodeValidated && (React.createElement("div", { className: "invalid-feedback d-block" }, "Sorry, we can't find your address, please check your address is correct.")),
                !whiteBackground && React.createElement("div", null,
                    React.createElement("button", { className: 'btn btn-primary btn-next-arrow-separate btn-find-address', id: 'find-address', onClick: this.handleSubmit }, "Find address")),
                React.createElement("div", null, !this.state.showAddressList && this.state.address && this.state.address.postcode && (React.createElement("button", { className: 'btn btn-default btn-white btn-find-address', id: 'cancel-find-address', onClick: this.cancelChanges }, "Cancel"))),
                this.state.showAddressList && (React.createElement("div", { className: "input-group" },
                    React.createElement("label", null, "Select address"),
                    React.createElement("p", null, "Please choose an address from the list or try a different postcode"),
                    this.renderFoundAddresses())),
                this.state.serviceError && (React.createElement("p", { className: "text-danger" }, "We are experiencing some technical issues, please come back later")))));
    };
    AddressLookupWidget.prototype.renderInputField = function () {
        return (React.createElement("div", { id: this.props.question.name },
            React.createElement(React.Fragment, null,
                this.state.showAddress ? this.renderDisplayAddress() : this.renderAddressInput(),
                this.state.serviceError && (React.createElement("p", { className: "text-danger" }, "We are experiencing some technical issues, please come back later")))));
    };
    AddressLookupWidget.prototype.renderFoundAddresses = function () {
        var addresses = [];
        if (this.state.addressList && this.state.addressList.length > 0) {
            var index_1 = 0;
            this.state.addressList.forEach(function (address) {
                var fullAddress = (0, commonFunctions_1.getFullAddressString)(address, false);
                addresses.push(React.createElement("option", { value: index_1 }, fullAddress));
                index_1++;
            });
            return (React.createElement("div", null,
                React.createElement("select", { id: this.props.question.name, className: "form-control", onChange: this.onSelectAddress },
                    React.createElement("option", { disabled: true, selected: true }, "Please select..."),
                    addresses)));
        }
        else {
            return null;
        }
    };
    AddressLookupWidget.prototype.handleSubmit = function () {
        var postcodeRegex = new RegExp("^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)|([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]?[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$");
        if (!this.state.postcode.trim()) {
            var errorMessage = "Please enter your postcode to continue";
            this.setState({
                postcodeValidated: false,
                postcodeErrorMessage: errorMessage
            });
            this.props.validations["postcode"] = {
                valid: false,
                errors: [errorMessage]
            };
        }
        else if (postcodeRegex.test(this.state.postcode.toUpperCase().trim())) {
            this.setState({
                postcodeValidated: true
            });
            this.props.validations["postcode"] = {
                valid: true,
                errors: []
            };
            this.findAddress();
        }
        else {
            var errorMessage = "Sorry, we can't find your address from that postcode. Please check it's correct. If your address is not recognised, we won't be able to offer you a quote.";
            this.setState({
                postcodeValidated: false,
                postcodeErrorMessage: errorMessage
            });
            this.props.validations["postcode"] = {
                valid: false,
                errors: [errorMessage]
            };
        }
    };
    AddressLookupWidget.prototype.toggleShowAddress = function (value) {
        var _this = this;
        delete this.props.validations["postcode"];
        delete this.props.validations["addressLookup"];
        this.setState({
            showAddress: value
        }, function () {
            _this.props.onStateChange("uistate.showAddress", value);
        });
    };
    AddressLookupWidget.prototype.handleBuildingChange = function (event) {
        this.setState({ building: event.target.value });
    };
    AddressLookupWidget.prototype.handlePostcodeChange = function (event) {
        this.setState({ postcode: event.target.value });
    };
    AddressLookupWidget.prototype.findAddress = function () {
        var _this = this;
        var address = this.state.postcode + " " + this.state.building;
        if (address !== " ") {
            this.setState({ isLoading: true });
            this.state.subscription.unsubscribe();
            var getAddressDetails = function (partialAddress) {
                if (services_1.productHelper.isHome(_this.props.interaction)) {
                    return _this.falconConvenienceApiService.getEalsAddressDetailsByPostcodeAndBuilding(_this.state.postcode, _this.state.building);
                }
                else {
                    return _this.falconConvenienceApiService.getAddressDetailsByPostcodeAndBuilding(partialAddress, null, null);
                }
            };
            var sub = getAddressDetails(address).subscribe(function (output) {
                _this.processAddressResponse(output);
                _this.setState({ isLoading: false });
            }, function () { return _this.setState({ serviceError: true, isLoading: false }); });
            this.setState({ subscription: sub });
        }
    };
    AddressLookupWidget.prototype.onSelectAddress = function (event) {
        var _this = this;
        if (!this.props.interaction.policyHolder) {
            this.props.interaction.policyHolder = {};
        }
        var addressDetails = this.state.addressList[event.target.value];
        if (services_1.productHelper.isHome(this.props.interaction)) {
            this.setState({ isLoading: true });
            this.falconConvenienceApiService.getEalsAddressDetails(addressDetails)
                .subscribe(function (fullAddressDetails) {
                var fullAddress = (0, commonFunctions_1.getFullAddressString)(fullAddressDetails, false);
                _this.setAddress(fullAddressDetails, fullAddress);
                _this.setState({
                    fullAddress: fullAddress,
                    address: fullAddressDetails,
                    addressList: [],
                    showAddressList: false,
                    postcodeValidated: true,
                    isLoading: false
                }, function () {
                    _this.validateInternal(fullAddress);
                });
            });
        }
        else {
            var fullAddress_1 = (0, commonFunctions_1.getFullAddressString)(addressDetails, false);
            this.setAddress(addressDetails, fullAddress_1);
            this.setState({
                fullAddress: fullAddress_1,
                address: this.state.addressList[event.target.value],
                addressList: [],
                showAddressList: false,
                postcodeValidated: true
            }, function () {
                _this.validateInternal(fullAddress_1);
                _this.toggleShowAddress(!_this.state.showAddress);
            });
        }
    };
    AddressLookupWidget.prototype.processAddressResponse = function (output) {
        var _this = this;
        var addressesDetails = output;
        if (addressesDetails.length === 1) {
            var foundAddress = addressesDetails[0];
            var fullAddress_2 = (0, commonFunctions_1.getFullAddressString)(addressesDetails[0], false);
            this.setAddress(foundAddress, fullAddress_2);
            this.setState({
                address: foundAddress,
                fullAddress: fullAddress_2,
                addressList: [],
                noAddressFound: false,
                showAddressList: false,
                showAddress: true,
                serviceError: false,
                postcodeValidated: true
            }, function () {
                _this.props.onStateChange("uistate.showAddress", true);
                _this.validateInternal(fullAddress_2);
            });
        }
        else if (addressesDetails.length > 1) {
            this.setState({
                addressList: addressesDetails,
                noAddressFound: false,
                showAddressList: true,
                showAddress: false,
                serviceError: false
            });
        }
        else {
            this.setState({
                addressList: [],
                noAddressFound: true,
                showAddressList: false,
                serviceError: false
            });
        }
    };
    AddressLookupWidget.prototype.cancelChanges = function () {
        delete this.props.validations["addressLookup"];
        this.toggleShowAddress(true);
        this.validateInternal(this.state.fullAddress);
    };
    AddressLookupWidget.prototype.setAddress = function (addressDetails, fullAddress) {
        var address = {};
        for (var _i = 0, _a = Object.keys(addressDetails); _i < _a.length; _i++) {
            var addressField = _a[_i];
            if (this.props.question.settings.interactionFields[addressField]) {
                address[addressField] = addressDetails[addressField];
            }
        }
        address.fullAddress = fullAddress;
        this.setState({ fullAddress: undefined });
        this.props.onStateChange("uistate.showAddress", true);
        this.props.onStateChange(this.props.question.interactionField, address);
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionFields["fullAddress"], this.props.page && this.props.page.pageId);
    };
    AddressLookupWidget.prototype.resize = function () {
        var currentIsMobile = (window.innerWidth < 768);
        if (currentIsMobile !== this.state.isMobileScreenSize) {
            this.setState({ isMobileScreenSize: currentIsMobile });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], AddressLookupWidget.prototype, "falconConvenienceApiService", void 0);
    return AddressLookupWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=AddressLookupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/AddressLookupWidget.js
// module id = 3493
// module chunks = 0